import { PrivateRoute } from "../../../shared/private-route";
import ListMakeupsContainer from "./list-container";
import AddMakeup from "./add";

const MakeupRoutes = () => {
  return (
    <>
      <PrivateRoute
        path="/films/:filmId/scenes/:sceneId/makeup"
        component={ListMakeupsContainer}
      />
      <PrivateRoute
        exact
        path="/films/:filmId/scenes/:sceneId/makeup/add"
        component={AddMakeup}
      />
    </>
  );
};

export default MakeupRoutes;
